export default values => ({
  billingName: values.billingName || ''
});
